module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-plano-in-richardson-texas-3c23142215280ded129f0a6ab7a3a6cf.png";